// Native disclosure menus and Shopify forms remain usable without JavaScript.
(()=>{
 // Choose a locale once; Shopify's native form preserves the current page.
 document.querySelectorAll('.mj-language-form').forEach(form=>{
  const select=form.querySelector('select[name="locale_code"]');
  if(!select||form.hasAttribute('data-mj-language-auto'))return;
  form.setAttribute('data-mj-language-auto','');
  select.addEventListener('change',()=>form.requestSubmit());
 });
 const menu=document.querySelector('[data-mj-menu]');
 document.addEventListener('keydown',event=>{if(event.key==='Escape'&&menu?.open){menu.open=false;menu.querySelector('summary').focus();}});
 document.addEventListener('click',event=>{if(menu?.open&&!menu.contains(event.target))menu.open=false;});
 menu?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{menu.open=false;}));
 const root=document.getElementById('mj-luxury');
 root?.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{
   root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   let count=0;root.querySelectorAll('[data-category]').forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.category!==button.dataset.filter;if(!card.hidden)count++;});
   const status=root.querySelector('.mj-filter-status');if(status)status.textContent=`${count} ${root.dataset.piecesShown}`;
 }));
 root?.querySelectorAll('[data-style]').forEach(button=>button.addEventListener('click',()=>{
   root.querySelectorAll('[data-style]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   root.querySelectorAll('[data-look]').forEach(panel=>{panel.hidden=panel.dataset.look!==button.dataset.style;});
   const status=root.querySelector('.mj-style-status');if(status)status.textContent=button.textContent.trim();
 }));
 // Keep the original AJAX cart system; only update our header count from its public event.
 if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{
   const count=event?.cartData?.item_count;if(typeof count!=='number')return;
   document.querySelectorAll('[data-mj-cart-count]').forEach(badge=>{badge.textContent=String(count);badge.hidden=count===0;});
 });
})();
